export const QUEST_PREFERENCES_STORAGE_KEY = "vocabularium_quest_preferences";

export const QUEST_JOURNAL_DETAIL_SCROLL_ANCHORS = {
  FREE: "free",
  OBJECTIVES: "objectives",
  REWARDS: "rewards",
};

export const QUEST_COMPLETED_OBJECTIVE_DISPLAY = {
  CHECK: "check",
  STRIKETHROUGH: "strikethrough",
};

export const QUEST_PROFILE_PORTRAIT_MODES = {
  PHOTO: "photo",
  BLASON: "blason",
};

export const DEFAULT_QUEST_PREFERENCES = {
  journalDetailScrollAnchor: QUEST_JOURNAL_DETAIL_SCROLL_ANCHORS.FREE,
  completedObjectiveDisplay: QUEST_COMPLETED_OBJECTIVE_DISPLAY.CHECK,
  profilePortraitMode: QUEST_PROFILE_PORTRAIT_MODES.PHOTO,
};

export const QUEST_JOURNAL_DETAIL_SCROLL_ANCHOR_LABELS = {
  [QUEST_JOURNAL_DETAIL_SCROLL_ANCHORS.FREE]: "Scroll libre",
  [QUEST_JOURNAL_DETAIL_SCROLL_ANCHORS.OBJECTIVES]: "Objectifs",
  [QUEST_JOURNAL_DETAIL_SCROLL_ANCHORS.REWARDS]: "Récompenses",
};

export const QUEST_COMPLETED_OBJECTIVE_DISPLAY_LABELS = {
  [QUEST_COMPLETED_OBJECTIVE_DISPLAY.CHECK]: "Utiliser le check",
  [QUEST_COMPLETED_OBJECTIVE_DISPLAY.STRIKETHROUGH]: "Barrer l'objectif",
};

export const QUEST_PROFILE_PORTRAIT_MODE_LABELS = {
  [QUEST_PROFILE_PORTRAIT_MODES.PHOTO]: "Votre photo",
  [QUEST_PROFILE_PORTRAIT_MODES.BLASON]: "Votre blason",
};

const VALID_JOURNAL_DETAIL_SCROLL_ANCHORS = new Set(
  Object.values(QUEST_JOURNAL_DETAIL_SCROLL_ANCHORS)
);

const VALID_COMPLETED_OBJECTIVE_DISPLAY = new Set(
  Object.values(QUEST_COMPLETED_OBJECTIVE_DISPLAY)
);

const VALID_PROFILE_PORTRAIT_MODES = new Set(Object.values(QUEST_PROFILE_PORTRAIT_MODES));

export function sanitizeQuestPreferences(raw) {
  if (!raw || typeof raw !== "object") {
    return { ...DEFAULT_QUEST_PREFERENCES };
  }

  return {
    journalDetailScrollAnchor: VALID_JOURNAL_DETAIL_SCROLL_ANCHORS.has(
      raw.journalDetailScrollAnchor
    )
      ? raw.journalDetailScrollAnchor
      : DEFAULT_QUEST_PREFERENCES.journalDetailScrollAnchor,
    completedObjectiveDisplay: VALID_COMPLETED_OBJECTIVE_DISPLAY.has(
      raw.completedObjectiveDisplay
    )
      ? raw.completedObjectiveDisplay
      : DEFAULT_QUEST_PREFERENCES.completedObjectiveDisplay,
    profilePortraitMode: VALID_PROFILE_PORTRAIT_MODES.has(raw.profilePortraitMode)
      ? raw.profilePortraitMode
      : DEFAULT_QUEST_PREFERENCES.profilePortraitMode,
  };
}

export function readQuestPreferences() {
  try {
    const stored = localStorage.getItem(QUEST_PREFERENCES_STORAGE_KEY);
    if (!stored) return { ...DEFAULT_QUEST_PREFERENCES };
    return sanitizeQuestPreferences(JSON.parse(stored));
  } catch {
    return { ...DEFAULT_QUEST_PREFERENCES };
  }
}

export function writeQuestPreferences(preferences) {
  try {
    localStorage.setItem(
      QUEST_PREFERENCES_STORAGE_KEY,
      JSON.stringify(sanitizeQuestPreferences(preferences))
    );
  } catch {
    // ignore quota errors
  }
}
